import Api from "../../Utils/Api";

//EDIT PROFILE
export const getProfileApi = () => async (dispatch) => {
    try {
        dispatch({
            type: "GET_PROFILE_REQUEST",
        });

        const { data } = await Api.get("users/profile");

        dispatch({
            type: "GET_PROFILE_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_PROFILE_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

//EDIT PROFILE
export const editProfileApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "EDIT_PROFILE_REQUEST",
        });

        const { data } = await Api.post("users/edit-profile", formData);

        dispatch({
            type: "EDIT_PROFILE_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "EDIT_PROFILE_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// CHANGE PASSWORD
export const changePasswordApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "CHANGE_PASSWORD_REQUEST",
        });

        const { data } = await Api.post("auth/change-password/", formData);

        dispatch({
            type: "CHANGE_PASSWORD_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "CHANGE_PASSWORD_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// DASHBOARD
export const dashboardGet = () => async (dispatch) => {
    try {
        dispatch({
            type: "DASHBOARD_GET_REQUEST",
        });

        const { data } = await Api.get("dashboard/data");

        dispatch({
            type: "DASHBOARD_GET_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "DASHBOARD_GET_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// ALL TENDER COMPANIES GET
export const getAllTendersCompanies = () => async (dispatch) => {
    try {
        dispatch({
            type: "GET_ALL_TENDERS_COMPANIES_REQUEST",
        });

        const { data } = await Api.get("tenders/total-active-company-tenders-dropdown");

        dispatch({
            type: "GET_ALL_TENDERS_COMPANIES_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_ALL_TENDERS_COMPANIES_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// INTERESTED COMPANIES
export const getIntrestedTenderCompanies = (currentPage = 1, limit = 1000) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_REQUEST",
        });

        const { data } = await Api.post(`tenders/total-company-tenders/?page=${currentPage}&limit=${limit}`);

        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

export const getInterestedTenderCompaniesDropdown = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_REQUEST",
        });

        const { data } = await Api.post(`tenders/total-company-tenders-dropdown`, formData);

        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// ALL TENDERS GET
export const getAllTenders = (formData, currentPage, limit) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_ALL_TENDERS_REQUEST",
        });

        const { data } = await Api.post(`tenders/company-tenders/?page=${currentPage}&limit=${limit}`, formData);

        dispatch({
            type: "GET_ALL_TENDERS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_ALL_TENDERS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// USER INTERESTED COMPANIES
export const userCompaniesFilter = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "SAVE_USER_INTERESTED_COMPANIES_REQUEST",
        });

        const { data } = await Api.post("tenders/set-selected-companies/", formData);

        dispatch({
            type: "SAVE_USER_INTERESTED_COMPANIES_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "SAVE_USER_INTERESTED_COMPANIES_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// GET DEPARTMENTS
export const getDepartments = () => async (dispatch) => {
    try {
        dispatch({
            type: "GET_DEPARTMENTS_REQUEST",
        });

        const { data } = await Api.get("department/");

        dispatch({
            type: "GET_DEPARTMENTS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_DEPARTMENTS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// ADD DEPARTMENT
export const addDepartment = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "ADD_DEPARTMENT_REQUEST",
        });

        const { data } = await Api.post("department/", formData);

        dispatch({
            type: "ADD_DEPARTMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "ADD_DEPARTMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// TENDERS SELECTED DEPARTMENT
export const selectDepartment = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "SELECT_DEPARTMENT_REQUEST",
        });

        const { data } = await Api.post("tenders/assign-tender-to-department/", formData);

        dispatch({
            type: "SELECT_DEPARTMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "SELECT_DEPARTMENT_FAILED",
            payload: e?.response?.data?.message[0][0],
            success: false,
        });
    }
};

// SELECTED TOTAL DEPARTMENTAL
export const selectedTotalDepartments = () => async (dispatch) => {
    try {
        dispatch({
            type: "SELECTED_TOTAL_DEPARTMENT_REQUEST",
        });

        const { data } = await Api.get("department/asign-tender-department/");

        dispatch({
            type: "SELECTED_TOTAL_DEPARTMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "SELECTED_TOTAL_DEPARTMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// ALL ASSIGNED TENDERS 
export const getAssignedTenders = (formData, currentPage, limit) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_ALL_ASSIGNED_TENDERS_REQUEST",
        });

        const { data } = await Api.post(`tenders/get-department-tenders/?page=${currentPage}&limit=${limit}`, formData ? formData : {});

        dispatch({
            type: "GET_ALL_ASSIGNED_TENDERS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_ALL_ASSIGNED_TENDERS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// ASSIGNED TENDERS STATUS 
export const assignedTenderStatus = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "ASSIGNED_TENDER_STATUS_REQUEST",
        });

        const { data } = await Api.post("tenders/is-interested-in-tender", formData);

        dispatch({
            type: "ASSIGNED_TENDER_STATUS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "ASSIGNED_TENDER_STATUS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};


// CHANGE DEPARTMENT 
export const changeDepartmentApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "CHANGE_DEPARTMENT_REQUEST",
        });

        const { data } = await Api.post("tenders/change-tender-department", formData);

        dispatch({
            type: "CHANGE_DEPARTMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "CHANGE_DEPARTMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// DELETE TENDER  
export const deleteTenderApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "DELETE_TENDER_REQUEST",
        });

        const { data } = await Api.post("tenders/delete-tender", formData);

        dispatch({
            type: "DELETE_TENDER_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "DELETE_TENDER_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// INTERESTED TENDERS GET 
export const getInterestedTenders = (formData, currentPage, limit) => async (dispatch) => {
    try {
        dispatch({
            type: "INTERESTED_TENDERS_GET_REQUEST",
        });

        const { data } = await Api.post(`tenders/get-department-interested-tenders/?page=${currentPage}&limit=${limit}`, formData ? formData : {});

        dispatch({
            type: "INTERESTED_TENDERS_GET_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "INTERESTED_TENDERS_GET_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// INTERESTED TENDERS DOCUMENT 
export const interestedTenderDocuments = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "INTERESTED_TENDER_DOCUMENTS_REQUEST",
        });

        const { data } = await Api.post("tms/proceedTenderForDocumentation/", formData);


        dispatch({
            type: "INTERESTED_TENDER_DOCUMENTS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "INTERESTED_TENDER_DOCUMENTS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// APPLIED TENDERS GET 
export const AppliedTendersGet = (formData, currentPage, limit) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_APPLIED_TENDERS_REQUEST",
        });

        const { data } = await Api.post(`tenders/applied-and-result-tenders/?page=${currentPage}&limit=${limit}`, formData);

        dispatch({
            type: "GET_APPLIED_TENDERS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_APPLIED_TENDERS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// APPLIED TENDER DOCUMENT 
export const appliedTenderDocument = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "APPLIED_TENDER_DOCUMENT_REQUEST",
        });

        const { data } = await Api.post("tms/uploadTenderDocumentAndComment/", formData);


        dispatch({
            type: "APPLIED_TENDER_DOCUMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "APPLIED_TENDER_DOCUMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// APPLY FOR TENDER 
export const applyForTender = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "APPLY_FOR_TENDER_REQUEST",
        });

        const { data } = await Api.post("tenders/tender-result-status", formData);


        dispatch({
            type: "APPLY_FOR_TENDER_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "APPLY_FOR_TENDER_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// TENDERS RESULTS GET 
export const getTendersResults = (currentPage, limit) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_TENDERS_RESULTS_REQUEST",
        });

        const { data } = await Api.post(`tenders/get-submitted-tenders/?page=${currentPage}&limit=${limit}`);


        dispatch({
            type: "GET_TENDERS_RESULTS_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_TENDERS_RESULTS_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// UPLOAD TENDERS RESULTS 
export const uploadTenderResults = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "UPLOAD_TENDER_RESULT_REQUEST",
        });

        const { data } = await Api.post("tms/uploadTenderResults/", formData);


        dispatch({
            type: "UPLOAD_TENDER_RESULT_SUCCESS",
            payload: data,
            success: true,
        });
    } catch (e) {
        dispatch({
            type: "UPLOAD_TENDER_RESULT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};